<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>Basic Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr class="rowList">
                                    <th class="listHeader tableLinerT" style="width:20%">National</th>
                                    <td class="tableLinerT text-left pl-5" style="width:30%">
                                        <v-select style="font-size:13px;" class="align-self-center" v-model="selectCountryCode" :items="countryList" item-text="info" item-value="vals" label="Country" outlined dense single-line hide-details></v-select>
                                    </td>
                                    <th class="listHeader tableLinerT" style="width:20%">Factory</th>
                                    <td class="tableLinerT text-left pl-5" style="width:30%">
                                        <div class="d-flex flat ">
                                            <v-select style="font-size:13px;" class="align-self-center" v-model="selectFactoryCode" :items="factoryList" item-text="info" item-value="vals" label="Factory" outlined dense single-line hide-details></v-select>
                                           
                                        </div>
                                    </td>
                                </tr>
                                <tr class="rowList">
                                    <th class="listHeader">Model</th>
                                    <td class="text-left pl-5">
                                        <div class="d-flex flat ">
                                            <v-select style="font-size:13px;" class="align-self-center " v-model="selectModelNum" :items="modelList" item-text="info" item-value="vals" label="Model" outlined dense single-line hide-details></v-select>
                                           
                                        </div>
                                    </td>
                                    <th class="listHeader" >Vehicle Identification Number</th>
                                    <td class="text-left pl-5"><v-text-field v-model="idtfyNums" outlined dense single-line hide-details small placeholder="vehicle Identification Number"></v-text-field></td>
                                </tr>
                                <tr class="rowList">
                                    <th class="listHeader">Registered User</th>
                                    <td class="text-left pl-5">
                                        <!--
                                        <v-select style="font-size:13px;" class="align-self-center" v-model="selectInsUsr" :items="managerList" item-text="info" item-value="vals" label="Manage User" outlined dense single-line hide-details></v-select>
                                        -->
                                        <MngSelect2 @mngID2="mngListUpt2"/>
                                    </td>
                                    <th class="listHeader">Approval User</th>
                                    <td class="text-left pl-5">
                                        <!--
                                        <v-select style="font-size:13px;" class="align-self-center " v-model="selectAprvUsr" :items="managerList" item-text="info" item-value="vals" label="Manage User" outlined dense single-line hide-details></v-select>
                                        -->
                                        <MngSelect @mngID="mngListUpt"/>
                                    </td>
                                </tr>
                                <tr class="rowList">
                                    <th class="listHeader">Status</th>
                                    <td class="tableLinerB text-left pl-5"><v-select style="font-size:13px;" class="align-self-center" v-model="selectAprvStatus" :items="approvalList" item-text="info" item-value="vals" label="Status" outlined dense single-line hide-details></v-select>
                                    </td>
                                    <th class="listHeader tableLinerB">Registration Date</th>
                                    <td class="tableLinerB text-left pl-5">
                                        <v-text-field v-model="today" outlined dense single-line hide-details small readonly ></v-text-field>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>
  
                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>Device Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr class="rowList">
                                    <th class="listHeader text-center" style="width:20%">Device</th>
                                    <th class="listHeader text-center" style="width:30%">ID</th>
                                    <th class="listHeader text-center">Memo</th>
                                </tr>
                                <tr class="rowList">
                                    <th class="listHeader2 tableLinerB text-left pl-5">VCU ID</th>
                                    <td class="tableLinerR tableLinerB text-left pl-5"><v-text-field v-model="vcuID" dense single-line hide-details small append-icon="mdi-magnify" readonly @click="openDevicePop('1')"></v-text-field></td>
                                    <td class="tableLinerB"><v-text-field v-model="cont1" dense single-line hide-details small outlined></v-text-field></td>
                                </tr>
                                <tr class="rowList">
                                    <th class="listHeader2 tableLinerB text-left pl-5">MCU ID</th>
                                    <td class="tableLinerR tableLinerB text-left pl-5"><v-text-field v-model="mcuID" dense single-line hide-details small append-icon="mdi-magnify" readonly @click="openDevicePop('2')"></v-text-field></td>
                                    <td class="tableLinerB"><v-text-field v-model="cont2" dense single-line hide-details small outlined></v-text-field></td>
                                </tr>
                                <tr class="rowList">
                                    <th class="listHeader2 tableLinerB text-left pl-5">Battery ID 1</th>
                                    <td class="tableLinerR tableLinerB text-left pl-5"><v-text-field v-model="cellID1" dense single-line hide-details small append-icon="mdi-magnify" @click="openDevicePop('3',1)" readonly></v-text-field></td>
                                    <td class="tableLinerB"><v-text-field v-model="cont3" dense single-line hide-details small outlined></v-text-field></td>
                                </tr>
                                <tr class="rowList">
                                    <th class="listHeader2 tableLinerB text-left pl-5">Battery ID 2</th>
                                    <td class="tableLinerR tableLinerB text-left pl-5"><v-text-field v-model="cellID2" dense single-line hide-details small append-icon="mdi-magnify" @click="openDevicePop('3',2)" readonly></v-text-field></td>
                                    <td class="tableLinerB"><v-text-field v-model="cont4" dense single-line hide-details small outlined></v-text-field></td>
                                </tr>
                            </tbody>
                        </v-simple-table>

                        <div class="d-flex justify-space-between dense pa-0 mt-5" >
                            <div class="pa2 " >
                                <v-btn dark class="backBtn px-5"  @click="goBack" >Cancel</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                                <v-btn dark class="registerBtn ml-2 px-6" @click="regBikeInfo">Save</v-btn>
                            </div>
                        </div>
                    </v-card>

                </div>
            </div>
        </div>
        <Footer/>

        <!-- Device List / Select (VCU/MCU/CELL Search Pop) -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="dvcFlag" width="500">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-3">
                        <span>{{schDvcTitle}} List</span>
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <div class="d-flex flat mb-2" style="max-height:38px;" >
                            <div class="d-flex mr-auto align-self-center font-weight-bold text-subtitle-1" >Total <span class="pl-2 listCnt">{{schDvcTotalCnt}}</span></div>
                            <div class="d-flex pr-2">
                                <v-text-field v-model="schDvcID" dense single-line hide-details small :placeholder="schDvcTitle">
                                </v-text-field>
                                <v-btn color="indigo" small class="d-flex align-self-center" icon @click="openDevicePop(schDvcClass, schExpTyp)"><v-icon>mdi-magnify</v-icon></v-btn>
                            </div>
                        </div>
                        
                        <v-simple-table fixed-header height="300px">
                            <thead style="position: sticky !important; top:0;z-index:9999">
                                <th class="listHeader text-center" style="width:60px;">No</th>
                                <th class="listHeader text-center" style="width:30%">National</th>
                                <th class="listHeader text-center" style="min-width:50px">Model</th>
                                <th class="listHeader text-center" style="width:50%">{{schDvcTitle}} ID</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item) in schDvcList" :key="item.SEQ">
                                    <td class="tableLinerR tableLinerB text-center pa-0 mr-0" style="width:40px;">
                                        <input type="radio" v-model="selectVcuID" name="vculist" :value="item.DVC_ID" @click="setDvcID(item.DVC_ID)">
                                    </td>
                                    <td class="tableLinerR tableLinerB popText">{{item.NAT_NAME}}</td>
                                    <td class="tableLinerR tableLinerB popText"> - </td>
                                    <td class="tableLinerB text-left pl-5" >
                                        <span @click="setDvcID(item.DVC_ID)">{{item.DVC_ID}}</span>
                                    </td>
                                    <!--
                                     <td class="tableLinerB text-right" >
                                        <div class="align-self-center">
                                            <v-btn icon color="red lighten-1" @click="delDvc(schDvcClass, item.DVC_ID);">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </td>
                                    -->
                                </tr>
                                <tr v-if="dvcEmptyFlag=='Y'">
                                    <td colspan="5" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions class="justify-center py-5">
                        <v-btn dark class="cancelBtn"  @click="closeDevicePop">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!-- Device Del / Confirm (VCU/MCU/CELL Search Pop) -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="dvcDelConfirmFlag" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon color='warning'>mdi-alert </v-icon>
                        <span class="pl-3">Do you want to delete? </span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="grey lighten-2" text @click="dvcDelConfirmFlag = false">Cancel</v-btn>
                        <v-btn color="red" text @click="dvcDelConfirmFlag = false">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!-- Alert Dialog / Save -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="alertFlag" width="450">
                <v-card>
                    <v-card-title class="text-subtitle-2 pb-0 text-wrap d-flex flat" style="width:450px;">
                        <v-icon class='d-flex' style='color:red;'>mdi-alert </v-icon>
                        <span class="d-flex pl-3">{{alertText}}</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="alertFlag = false;regFlag='Y'">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncSuccess-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="goList">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="asyncErrors=false;">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList:hover { background-color: transparent !important;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    .popText { font-size:12px !important;}
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import MngSelect from '@/components/cfgManager.vue'
import MngSelect2 from '@/components/cfgManager2.vue'

export default {
    name: 'VehicleWrite',
    components: { Gnb, Footer, PageCrumbs,  Navs, MngSelect, MngSelect2 },
    data () {
        return {
            // login Info
            gnbCode:"1", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:12, 

            // Page Title & Breadcrumbs
            pTitles: "차량 등록(수정)",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: '차량관리', disabled: true,}, { text: '차량현황', disabled: true,}, { text: '차량등록(수정)', disabled: false,}],
            NavList: [
              {
                items: [
                  { title: 'Vehicle List', nums:11, href:'/Vehicle', icons:'mdi-format-list-bulleted' },
                  { title: 'New Registration', nums:12, href:'/VehicleWrite', icons:'mdi-lead-pencil' },
                ],
                title: 'Vehicle Management', nums: '1'
              },
              {
                items: [
                  { title: 'Contract List',nums:21, href:'/VehicleRLS', icons:'mdi-format-list-bulleted' },
                  { title: 'New Contract Registration', nums:22, href:'/VehicleRLS2', icons:'mdi-lead-pencil' },
                ],
                title: 'Contract Management', nums: '2'
              },
            ], 
            continentCode: "", 
            //countryCode: "",factoryCode: "", modelNum: "", aprvStatus: "", insUsr:"", aprvUsr:"",
            idtfyNums: "", vcuID: "",mcuID: "",cellID1: "",cellID2: "", 
            cont1:"", cont2:"", cont3:"", cont4:"", 
            regDate: "",

            selectCountryCode:"", selectFactoryCode:"", selectModelNum:"", selectAprvStatus:"", 
            selectInsUsr:"", selectAprvUsr:"",
            
            today: new Date().toISOString().substr(0, 10),

            countryList:[{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}], 
            factoryList:[{info: 'E3 용인 공장', vals: "1"}], 
            modelList: [{info:'Deux 7(E3 Blade)', vals:"1"}], 
            managerList:[{info:'admin', vals:'admin'},{info:'manager', vals:'manager'}],
            approvalList: [{info: 'Assigned', vals: 6}, {info: 'Rejected', vals: 4}, {info: 'Ready', vals: 5}],

            dvcFlag:false, 
            schDvcClass:"", schExpID:"", schExpTyp:"", schDvcID:"", 
            schDvcTitle:"VCU ID", schDvcTotalCnt:0, schDvcList:[], schDvcType:"", dvcEmptyFlag:'Y', dvcDelConfirmFlag: false,
            selectVcuID:"", selectMcuID:"", selectCellID1:"", selectCellID2:"",

            regFlag:'Y', alertFlag:false, alertText:'', 
            asyncErrors: false, asyncSuccess: false, asyncActType: "C",

            editFlag: false,
            editEbkSeq:'',
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                //console.log("login-"+json.chkVal);
                //console.log("login-"+json.EXP_DTM);
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");

        //console.log('param 확인' + this.$route.params.ebkSeq);
        this.editEbkSeq = this.$route.params.ebkSeq;
        if(this.editEbkSeq != '' && this.$route.params.ebkSeq != undefined ) {
            this.navCode2=11;
            this.pTitles = "Edit";
            this.pCrumbs = [ { text: 'Home', disabled: true,}, { text: 'Vehicle', disabled: true,}, { text: 'Vehicle List', disabled: true,}, { text: 'Edit', disabled: false,}];

            this.getInfo();

        } else {
            this.navCode2=12;
            this.pTitles = "New Registration";
            this.pCrumbs = [ { text: 'Home', disabled: true,}, { text: 'Vehicle', disabled: true,}, { text: 'Vehicle List', disabled: true,}, { text: 'New Registration', disabled: false,}];
        }
        window.scrollTo(0, 0);
        
    },

    methods: {
        
        // getCountry | getFactory | getModel | getManager     
        mngListUpt(arg){
            this.selectAprvUsr = arg;
            //console.log("selectAprvUsr="+this.selectAprvUsr);
        },    

        mngListUpt2(arg){
            this.selectInsUsr = arg;
            //console.log("selectInsUsr="+this.selectInsUsr);
        },  

        // back button
        goBack() {
            if(this.editEbkSeq != '' && this.$route.params.ebkSeq != undefined ) {
                this.$router.push({ name: 'VehicleDetail', params: { ebkSeq: this.editEbkSeq }});
            } else {
                //return this.$router.go(-1);
                this.$router.push({ name: 'Vehicle'});
            }
        }

        , setDvcID(vals) {
            if(this.schDvcClass == "1") {
                this.vcuID = vals;
            } else if(this.schDvcClass == "2") {
                this.mcuID = vals;
            } else if(this.schDvcClass == "3") {
                    if(this.schExpTyp == 1) {
                        this.cellID1 = vals;
                    } else if(this.schExpTyp == 2) {
                        this.cellID2 = vals;
                    }
            }
            this.dvcFlag = false;
        },

        delDVC(arg1, arg2) {
            console.log(arg1, arg2);
        },

        openDevicePop(arg, cls) {
            if(arg != "") {
                this.dvcFlag = true;
                this.schDvcClass = arg;
                if(arg == "3") {
                    this.schExpTyp = cls;
                    if(cls == 1 && this.cellID2 != '') {
                        this.schExpID = this.cellID2;
                    } else if(cls == 2 && this.cellID1 != '') {
                        this.schExpID = this.cellID1;
                    }
                    this.schDvcTitle = "Battery";
                } else if(arg == "1") {
                    this.schDvcTitle = "VCU ";
                } else if(arg == "2") {
                    this.schDvcTitle = "MCU";
                }
                var requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "usrID": this.loginInfo1
                        , "authCode": this.loginInfo3
                        , "act": "L"
                        , "schDvcClass": arg
                        , "schText": this.schDvcID 
                        , "exceptionID": this.schExpID
                    })
                };
                
                fetch('https://api.e3bss.com/_APP/POC/dvcInfo.php', requestOptions)
                .then((response) => {
                   if(response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                }).then((json) => {
                    //console.log(json);
                    //console.log(json.value.list );
                    if(json.result == "success") {
                        this.schDvcList = json.value.list;
                        this.schDvcTotalCnt = json.totalCnt;
                        this.dvcEmptyFlag = "N";
                    } else {
                        this.schDvcList = [];
                        this.schDvcTotalCnt = 0;
                        this.dvcEmptyFlag = "Y";
                    }
                    this.schDvcID = "";
                }).catch(() => {
                    //console.log(error);
                    this.$router.replace('Error');
                });
            }
        },

        closeDevicePop() {
            this.dvcFlag = false;
        },

        regBikeInfo() {
            if(this.selectCountryCode == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'National');
                return;
            }
            
            if(this.selectFactoryCode == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Factory');
                return;
            }
            
            /*
            if(this.selectModelNum == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Vehicle Model');
                return;
            }
            */
            if(this.idtfyNums == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Vehicle Identification Number');
                return;
            }
            if(this.selectInsUsr == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Registered User');
                return;
            }
            if(this.selectAprvUsr == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Approval User');
                return;
            }
            if(this.selectAprvStatus == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Status');
                return;
            }
            /*
            if(this.vcuID == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'VCU ID');
                return;
            }
            
            if(this.mcuID == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'MCU ID');
                return;
            }
            if(this.cellID1 == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Battery ID 1');
                return;
            }
            if(this.cellID2 == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Battery ID 2');
                return;
            }
            */
            var param =JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": this.asyncActType
                    , "countryCode": this.selectCountryCode, "factoryCode": this.selectFactoryCode
                    , "modelNum": this.selectModelNum, "idtfyNums": this.idtfyNums
                    , "insUsr": this.selectInsUsr, "aprvUsr": this.selectAprvUsr
                    , "aprvStatus": this.selectAprvStatus, "regDate": this.today
                    , "vcuID": this.vcuID, "mcuID": this.mcuID
                    , "cellID1": this.cellID1, "cellID2": this.cellID2
                    , "cont1":this.cont1, "cont2":this.cont2
                    , "cont3":this.cont3, "cont4":this.cont4
                    , "ebkSeq": this.editEbkSeq
                });
                //console.log("param="+param);
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: param
            };
                
            fetch('https://api.e3bss.com/_APP/POC/eBike.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                //console.log(json.value.list );
                if(json.result == "success") {
                    this.asyncSuccess=true;
                } else {
                    this.asyncErrors = true;
                }  
            })
            .catch(() => {
                this.asyncErrors = true;
                //console.log(error);
            });
        },

        alertToForm(arg1, arg2) {
            var str1 = "enter";
            var strInfo1 = "Please"; var strInfo2 = "information";
            if(arg1 == 2) str1 = 'select';
            this.alertText = strInfo1 +' '+ str1 +' '+ arg2 +' '+ strInfo2+".";
            // Please select country information 
        },

        goList(){
            this.asyncSuccess=false;this.$router.push("Vehicle");
        },

        // Edit - API Async 
        getInfo() {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "ebkSeq": this.editEbkSeq
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/eBike.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result);
                //console.log(json);
                if(json.result == "success") {
                    this.editFlag=true;
                    this.asyncActType="U";
                    //this.countryCode = json.COUNTRY_CODE; 
                    //this.selectCountryCode.info = json.NAT_NAME_KR; 
                    //this.selectCountryCode.vals = json.COUNTRY_CODE;
                    this.selectCountryCode = json.COUNTRY_CODE; 
                    //this.factoryCode = json.FACTORY_CODE; 
                    //this.selectFactoryCode.info = json.FAC_NAME_KR; 
                    //this.selectFactoryCode.vals = json.FACTORY_CODE; 
                    this.selectFactoryCode = json.FACTORY_CODE; 
                    //this.modelNum = json.EBK_MODEL; 
                    //this.selectModelNum.info = json.EBK_MODEL_NAME;
                    //this.selectModelNum.vals = json.EBK_MODEL; 
                    this.selectModelNum = json.EBK_MODEL; 

                    this.idtfyNums = json.EBK_IDTFY_NUMS;
                    this.vcuID = json.VCU_ID; this.mcuID = json.MCU_ID; this.cellID1 = json.CELL_ID1; this.cellID2 = json.CELL_ID2; 
                    this.cont1 = json.CONT1; this.cont2 = json.CONT2; this.cont3 = json.CONT3; this.cont4 = json.CONT4; 
                    //this.aprvStatus = json.APRV_STATUS;
                    //this.selectAprvStatus.info = json.APRV_INFO;
                    //this.selectAprvStatus.vals = json.APRV_STATUS;
                    this.selectAprvStatus = json.APRV_STATUS;
                    this.regDate = json.INS_DTM; 
                    //this.insUsr = json.INS_USR_ID; 
                    //this.selectInsUsr.info = json.INS_USR_ID;
                    //this.selectInsUsr.vals = json.INS_USR_ID; 
                    this.selectInsUsr = json.INS_USR_ID; 
                    //this.aprvUsr = json.APRV_USR_ID; 
                    //this.selectAprvUsr.info = json.APRV_USR_ID;
                    //this.selectAprvUsr.vals = json.APRV_USR_ID; 
                    this.selectAprvUsr = json.APRV_USR_ID; 
                    //console.log(this.selectCountryCode+"|"+this.selectFactoryCode+"|"+this.selectModelNum+"|"+this.selectAprvStatus+"|"+this.selectInsUsr+"|"+this.selectAprvUsr);
                } else {
                    this.asyncErrors = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },
    
    }

}
</script>
